import Resources from '@components/admin/dashboard/Resources';
import WelcomeMessage from '@components/admin/dashboard/WelcomeMessage';
import AnnouncementStream from '@components/common/announcement/AnnouncementStream';
import ContentBox from '@components/common/ContentBox';
import PageHeader from '@components/common/PageHeader';
import React from 'react';

const AdminDashboard: React.FC = () => {
  return (
    <div className='w-full h-full overflow-auto font-raleway'>
      <PageHeader text='ADMIN PORTAL'></PageHeader>
      <div className='grid grid-cols-1 lg:grid-cols-3 lg:grid-rows-2 gap-4 grid-flow-row lg:grid-flow-col my-10 sm:mx-14 min-h-2/3'>
        <ContentBox className='lg:col-span-1 lg:row-span-full' center={false}>
          <WelcomeMessage></WelcomeMessage>
        </ContentBox>
        <ContentBox className='lg:col-start-2 lg:col-span-2 lg:row-span-1'>
          <AnnouncementStream></AnnouncementStream>
        </ContentBox>
        <ContentBox className='lg:col-start-2 lg:col-span-2 lg:row-span-1' center={false}>
          <Resources></Resources>
        </ContentBox>
      </div>
    </div>
  );
};

export default AdminDashboard;
